import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { saveAs } from 'file-saver';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { acceptedFileTypes, acceptedFileTypesText } from 'app-models';
import { DeleteDialogLibraryComponent, DeleteDialogLibraryModule } from 'delete-dialog-library';
import { DeleteDialogConfigurations } from 'dialog-configuration-library';
import * as i4 from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from 'environment-configurations';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i1$1 from 'ngx-toastr';
import * as i3 from 'reference-library';
import * as i5 from '@angular/common';
import * as i6 from 'primeng/dropdown';
import * as i7 from '@angular/forms';
import * as i8 from 'primeng/inputtext';
import * as i9 from 'primeng/fileupload';
import * as i10 from 'primeng/table';
import * as i11 from 'primeng/api';
import * as i12 from 'primeng/button';
import * as i13 from 'primeng/tooltip';
import * as i14 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class FileUploadLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    uploadDocument(url, payload) {
        return this.httpClient.post(url, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getUploadedDocument(url) {
        return this.httpClient.get(url).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    deleteUploadDocument(url) {
        return this.httpClient.delete(url).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadDocuments(path, fileName) {
        this.httpClient.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
}
FileUploadLibraryService.ɵfac = function FileUploadLibraryService_Factory(t) { return new (t || FileUploadLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
FileUploadLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: FileUploadLibraryService, factory: FileUploadLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function FileUploadLibraryComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 11);
    i0.ɵɵlistener("ngModelChange", function FileUploadLibraryComponent_div_1_div_1_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.configurations.documentTypeDropdownCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r4.configurations.disableControls)("options", ctx_r4.listDocumentTypes)("ngModel", ctx_r4.configurations.documentTypeDropdownCode);
} }
function FileUploadLibraryComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 13);
    i0.ɵɵlistener("ngModelChange", function FileUploadLibraryComponent_div_1_div_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.otherName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r5.otherName);
} }
function FileUploadLibraryComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "p-fileUpload", 14, 15);
    i0.ɵɵlistener("uploadHandler", function FileUploadLibraryComponent_div_1_div_3_Template_p_fileUpload_uploadHandler_1_listener($event) { i0.ɵɵrestoreView(_r13); const _r11 = i0.ɵɵreference(2); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onUploadHandle($event, _r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r6.configurations.disableControls || ctx_r6.configurations.documentTypeDropdownCode == "" || ctx_r6.configurations.documentTypeDropdownCode === "OTHER" && ctx_r6.otherName.trim() === "")("accept", ctx_r6.acceptedTypes)("auto", true);
} }
function FileUploadLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, FileUploadLibraryComponent_div_1_div_1_Template, 4, 3, "div", 8);
    i0.ɵɵtemplate(2, FileUploadLibraryComponent_div_1_div_2_Template, 4, 1, "div", 3);
    i0.ɵɵtemplate(3, FileUploadLibraryComponent_div_1_div_3_Template, 3, 3, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.configurations.isDocumentTypeRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.configurations.documentTypeDropdownCode === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.configurations.isDocumentUploadRequired);
} }
function FileUploadLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} }
function FileUploadLibraryComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} }
function FileUploadLibraryComponent_div_8_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 21);
    i0.ɵɵtext(2, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 21);
    i0.ɵɵtext(4, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 21);
    i0.ɵɵtext(6, "Actions ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FileUploadLibraryComponent_div_8_ng_template_5_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "button", 27);
    i0.ɵɵlistener("click", function FileUploadLibraryComponent_div_8_ng_template_5_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r22); const file_r16 = i0.ɵɵnextContext().$implicit; const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.openDoc(file_r16); });
    i0.ɵɵelementStart(2, "mat-icon", 28);
    i0.ɵɵtext(3, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !file_r16.fileLocation);
} }
function FileUploadLibraryComponent_div_8_ng_template_5_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "button", 29);
    i0.ɵɵlistener("click", function FileUploadLibraryComponent_div_8_ng_template_5_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r26); const file_r16 = i0.ɵɵnextContext().$implicit; const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.download(file_r16); });
    i0.ɵɵelementStart(2, "mat-icon", 30);
    i0.ɵɵtext(3, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FileUploadLibraryComponent_div_8_ng_template_5_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "button", 31);
    i0.ɵɵlistener("click", function FileUploadLibraryComponent_div_8_ng_template_5_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r29); const file_r16 = i0.ɵɵnextContext().$implicit; const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.deleteDocumentTypeLis(file_r16); });
    i0.ɵɵelementStart(2, "mat-icon", 30);
    i0.ɵɵtext(3, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r19.configurations.disableControls);
} }
function FileUploadLibraryComponent_div_8_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵelementStart(4, "a", 22);
    i0.ɵɵlistener("click", function FileUploadLibraryComponent_div_8_ng_template_5_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r31); const file_r16 = ctx.$implicit; const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.openDoc(file_r16); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 23);
    i0.ɵɵelementStart(7, "div", 24);
    i0.ɵɵtemplate(8, FileUploadLibraryComponent_div_8_ng_template_5_div_8_Template, 4, 1, "div", 25);
    i0.ɵɵtemplate(9, FileUploadLibraryComponent_div_8_ng_template_5_div_9_Template, 4, 0, "div", 25);
    i0.ɵɵtemplate(10, FileUploadLibraryComponent_div_8_ng_template_5_div_10_Template, 4, 1, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r16 = ctx.$implicit;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", file_r16.fileCategory ? file_r16.fileCategory.code === "OTHER" ? file_r16.fileCtaegoryOtherName ? file_r16.fileCtaegoryOtherName : file_r16.fileCategory.name : file_r16.fileCategory.name : "-", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", file_r16 == null ? null : file_r16.fileName, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r15.configurations.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", file_r16.fileLocation && ctx_r15.configurations.isDownloadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.configurations.isDeleteEnabled);
} }
function FileUploadLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "h6", 17);
    i0.ɵɵtext(2, "List of Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-table", 18);
    i0.ɵɵtemplate(4, FileUploadLibraryComponent_div_8_ng_template_4_Template, 7, 0, "ng-template", 19);
    i0.ɵɵtemplate(5, FileUploadLibraryComponent_div_8_ng_template_5_Template, 11, 5, "ng-template", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r3.uploadedFiles);
} }
class FileUploadLibraryComponent {
    constructor(toasterService, uploadService, referenceLibraryService, dialogService) {
        this.toasterService = toasterService;
        this.uploadService = uploadService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.isShowUploadedList = true;
        this.isFileListModified = new EventEmitter();
        this.fileListCount = new EventEmitter();
        this.filesDataChange = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.maxfileSizeInMB = 10;
        this.acceptedTypes = acceptedFileTypes;
        this.acceptedTypesText = acceptedFileTypesText;
        this.uploadedFiles = [];
        this.listDocumentTypes = [];
        this.configurations = {
            disableControls: false,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            postApiUrl: '',
            getApiUrl: '',
            deleteApiUrl: '',
            documentTypeDropdownCode: ''
        };
        this.otherName = '';
    }
    onUploadHandle(event, fubauto) {
        if (this.configurations.documentTypeDropdownCode === 'OTHER' && this.otherName.trim() === '') {
            CustomErrorToastComponent.showErrorToast(this.toasterService, 'Document Type Name is required');
            fubauto.clear();
            return false;
        }
        const file = event.files[0];
        file.fileName = event.files[0].name;
        if (file.size / 1024 / 1024 > this.maxfileSizeInMB) {
            CustomErrorToastComponent.showErrorToast(this.toasterService, `File size should be less than or equal to ${this.maxfileSizeInMB}MB`);
            fubauto.clear();
            return;
        }
        const payload = new FormData();
        payload.append('file', file, file.name);
        let apiUrl;
        if (this.configurations.isOutside) {
            const categoryVal = this.listDocumentTypes.find(item => item.code === this.configurations.documentTypeDropdownCode);
            apiUrl = this.configurations.documentTypeDropdownCode === 'OTHER' ?
                `${this.configurations.postApiUrl}/${categoryVal.group}/fileCategory/` + `${this.configurations.documentTypeDropdownCode}` +
                    '?otherName=' + `${this.otherName}` : `${this.configurations.postApiUrl}/${categoryVal.group}/fileCategory/${this.configurations.documentTypeDropdownCode}`;
        }
        else {
            if (this.configurations.documentTypeDropdownCode === 'OTHER') {
                apiUrl = `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode}` + '?otherName=' + `${this.otherName}`;
            }
            else if (this.configurations.documentTypeDropdownCode === 'RECNOTC') {
                if ((this.primaryData && this.primaryData.visatype === 'ASYLUM')) {
                    apiUrl = `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode}`;
                }
                else {
                    apiUrl = `${this.configurations.postApiUrl}`;
                }
            }
            else {
                apiUrl = `${this.configurations.postApiUrl}` + `${this.configurations.documentTypeDropdownCode}`;
            }
        }
        if (this.configurations.isPetitionerDetailsDocuments) {
            if (this.configurations.documentTypeDropdownCode === 'OTHER') {
                apiUrl = `${apiUrl}&entityId=${this.configurations.petitionerDetailsDocumentsCompanyId}`;
            }
            else {
                apiUrl = `${apiUrl}?entityId=${this.configurations.petitionerDetailsDocumentsCompanyId}`;
            }
        }
        if (this.configurations.familyId) {
            if (this.configurations.isPetitionerDetailsDocuments || this.configurations.documentTypeDropdownCode === 'OTHER') {
                apiUrl = `${apiUrl}&familyId=${this.configurations.familyId}`;
            }
            else {
                apiUrl = `${apiUrl}?familyId=${this.configurations.familyId}`;
            }
        }
        this.uploadService.uploadDocument(apiUrl, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.toasterService.success(response.message, 'Success');
            this.isFileListModified.emit(true);
            this.filesDataChange.emit(response);
            this.otherName = '';
            this.getDocuments();
            if (this.configurations.isDocumentTypeRequired) {
                this.configurations.documentTypeDropdownCode = '';
            }
            fubauto.clear();
        });
    }
    getDocuments() {
        if (this.configurations.getApiUrl) {
            let apiUrl = this.configurations.getApiUrl;
            if (this.configurations.familyId) {
                apiUrl = `${this.configurations.getApiUrl}?familyId=${this.configurations.familyId}`;
            }
            this.uploadService.getUploadedDocument(apiUrl)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.uploadedFiles = Object.assign([], response.data);
                this.fileListCount.emit(this.uploadedFiles ? this.uploadedFiles.length : 0);
            });
        }
    }
    getDocumentTypeList() {
        this.configurations.documentTypeDropdownCode = '';
        this.referenceLibraryService.getReferenceDocTypeData(this.configurations.getDocTypeApiUrl)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (this.configurations.isOutside) {
                this.listDocumentTypes = response.map(x => {
                    var _a;
                    return {
                        code: x.entityType.code,
                        //name: this.configurations?.isOutside ? `${x.titleSheetName} - ${x.docName}` : x.docName, // IM-10849 issue fix
                        name: ((_a = this.configurations) === null || _a === void 0 ? void 0 : _a.isOutside) ? x.entityType.name : x.docName,
                        id: x.entityType.id,
                        desc: x.entityType.description,
                        group: x.entityType.group,
                        entityType: x.entityType
                    };
                });
            }
            else {
                this.listDocumentTypes = response;
            }
        });
    }
    deleteDocumentTypeLis(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.uploadService.deleteUploadDocument(`${this.configurations.deleteApiUrl}${this.configurations.deleteFileCategoryNeeded ? input.fileCategory.code + '/' : ''}${input.id}`)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((responseUploadedDocs) => {
                    this.toasterService.success(responseUploadedDocs.message, 'Success');
                    this.isFileListModified.emit(true);
                    this.getDocuments();
                });
            }
        });
    }
    ngOnChanges(e) {
        if (e.fileUploadConfigurations && e.fileUploadConfigurations.currentValue) {
            this.configurations = e.fileUploadConfigurations.currentValue;
            if (this.configurations.isDocumentTypeRequired) {
                this.getDocumentTypeList();
            }
            // if (this.configurations.documentTypeDropdownCode) {
            this.getDocuments();
            // }
        }
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    download(file) {
        this.uploadService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
FileUploadLibraryComponent.ɵfac = function FileUploadLibraryComponent_Factory(t) { return new (t || FileUploadLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.ToastrService), i0.ɵɵdirectiveInject(FileUploadLibraryService), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService), i0.ɵɵdirectiveInject(i4.DialogService)); };
FileUploadLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FileUploadLibraryComponent, selectors: [["file-upload-library"]], inputs: { fileUploadConfigurations: "fileUploadConfigurations", isShowUploadedList: "isShowUploadedList", primaryData: "primaryData" }, outputs: { isFileListModified: "isFileListModified", fileListCount: "fileListCount", filesDataChange: "filesDataChange" }, features: [i0.ɵɵProvidersFeature([DialogService]), i0.ɵɵNgOnChangesFeature], decls: 9, vars: 5, consts: [[1, "container-fluid"], ["class", "col-md-9 p-0 row d-flex- align-items-end", 4, "ngIf"], [1, "col-md-9", "p-0", "pb-3", "row", "d-flex-", "align-items-end"], ["class", "col-md-4 p-0 pr-2", 4, "ngIf"], [1, "col-md-4", "pl-0"], [1, "label-cls", "single-file-upload", "d-block", "pt-1"], ["class", "mb-5 pt-2 uploaded-item-list", 4, "ngIf"], [1, "col-md-9", "p-0", "row", "d-flex-", "align-items-end"], ["class", "col-md-4 p-0 pr-2 processing-dropdown", 4, "ngIf"], ["class", "col-md-4 pl-0", 4, "ngIf"], [1, "col-md-4", "p-0", "pr-2", "processing-dropdown"], ["appendTo", "body", "placeholder", "Select Category", "optionValue", "code", "optionLabel", "name", 3, "disabled", "options", "ngModel", "ngModelChange"], [1, "col-md-4", "p-0", "pr-2"], ["type", "text", "pInputText", "", 3, "ngModel", "ngModelChange"], ["mode", "basic", "customUpload", "true", "name", "demo[]", "chooseLabel", "Browse", 3, "disabled", "accept", "auto", "uploadHandler"], ["fubauto", ""], [1, "mb-5", "pt-2", "uploaded-item-list"], [1, "labelText", "heading"], ["name", "uploadedFiles", 1, "table-striped-simple", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["scope", "col"], [2, "cursor", "pointer", 3, "click"], [1, "text-center"], [1, "d-flex", "flex-row", "documents-icons", "d-flex", "align-items-center"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0"], ["pButton", "", "type", "button", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", "p-0", 3, "disabled", "click"], ["matTooltip", "View", 1, "mr-1", "icn"], ["pButton", "", "type", "button", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", "p-0", 3, "click"], ["matTooltip", "Delete", 1, "mr-1", "icn"], ["pButton", "", "type", "button", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", "p-0", 3, "disabled", "click"]], template: function FileUploadLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, FileUploadLibraryComponent_div_1_Template, 4, 3, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, FileUploadLibraryComponent_div_3_Template, 1, 0, "div", 3);
        i0.ɵɵtemplate(4, FileUploadLibraryComponent_div_4_Template, 1, 0, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "label", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, FileUploadLibraryComponent_div_8_Template, 6, 1, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.configurations.isDocumentTypeRequired || ctx.configurations.isDocumentUploadRequired);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.configurations.isDocumentTypeRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.configurations.documentTypeDropdownCode === "OTHER");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.acceptedTypesText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.uploadedFiles == null ? null : ctx.uploadedFiles.length) > 0 && ctx.isShowUploadedList);
    } }, directives: [i5.NgIf, i6.Dropdown, i7.NgControlStatus, i7.NgModel, i7.DefaultValueAccessor, i8.InputText, i9.FileUpload, i10.Table, i11.PrimeTemplate, i12.ButtonDirective, i13.Tooltip, i14.MatIcon], styles: [".documents-icons[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{cursor:pointer;font-size:18px;padding-right:8px}.pa-table[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.pa-table[_ngcontent-%COMP%]   .table-btn[_ngcontent-%COMP%]{padding:7px!important}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;color:#4a4a4a;font:normal normal 600 14px/20px Source Sans Pro}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:none!important;padding:15px 15px 0!important;font:normal normal normal 14px/21px Source Sans Pro;color:#4a4a4a}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 8px!important;color:#75777a}.documents-icons[_ngcontent-%COMP%]   .p-button-text[_ngcontent-%COMP%]{padding-left:10px;padding-right:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'file-upload-library',
                templateUrl: './file-upload-library.component.html',
                styleUrls: ['./file-upload-library.component.scss'],
                providers: [DialogService]
            }]
    }], function () { return [{ type: i1$1.ToastrService }, { type: FileUploadLibraryService }, { type: i3.ReferenceLibraryService }, { type: i4.DialogService }]; }, { fileUploadConfigurations: [{
            type: Input
        }], isShowUploadedList: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], isFileListModified: [{
            type: Output
        }], fileListCount: [{
            type: Output
        }], filesDataChange: [{
            type: Output
        }] }); })();

class FileUploadLibraryModule {
}
FileUploadLibraryModule.ɵfac = function FileUploadLibraryModule_Factory(t) { return new (t || FileUploadLibraryModule)(); };
FileUploadLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: FileUploadLibraryModule });
FileUploadLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            DeleteDialogLibraryModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FileUploadLibraryModule, { declarations: [FileUploadLibraryComponent], imports: [DeleteDialogLibraryModule,
        PrimengLibraryModule], exports: [FileUploadLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [FileUploadLibraryComponent],
                imports: [
                    DeleteDialogLibraryModule,
                    PrimengLibraryModule
                ],
                exports: [FileUploadLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of file-upload-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FileUploadLibraryComponent, FileUploadLibraryModule, FileUploadLibraryService };
//# sourceMappingURL=file-upload-library.js.map
